import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import { socialUrls } from 'constants';

// One circle per network: a hairline ring at rest, gold on hover. The icon carries the whole
// meaning, so each link needs an aria-label - there is no text for a screen reader to read.
const socialIconSx = {
  width: 40,
  height: 40,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  border: '1px solid',
  borderColor: 'hairline.strong',
  color: 'text.secondary',
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    borderColor: 'gold.fill',
    color: 'gold.fill'
  }
};

const networks = [
  { name: 'Facebook', href: socialUrls.facebook, Icon: FacebookIcon },
  { name: 'Instagram', href: socialUrls.instagram, Icon: InstagramIcon }
];

// justifyContent is the one thing callers differ on: the footer keeps the row left-aligned in its
// column, the order confirmation centres it under the heading.
export default function SocialLinks({ justifyContent = 'flex-start', size = 'default' }) {
  const isLarge = size === 'large';

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', gap: isLarge ? 2 : 1.5, justifyContent }}>
      {networks.map(({ name, href, Icon }) => (
        <Box
          key={name}
          component="a"
          href={href}
          target="_blank"
          rel="noreferrer"
          aria-label={name}
          sx={{
            ...socialIconSx,
            width: isLarge ? 56 : socialIconSx.width,
            height: isLarge ? 56 : socialIconSx.height
          }}>
          <Icon sx={{ width: isLarge ? 32 : 22, height: isLarge ? 32 : 22 }} />
        </Box>
      ))}
    </Box>
  );
}

SocialLinks.propTypes = {
  justifyContent: PropTypes.string,
  size: PropTypes.oneOf(['default', 'large'])
};
